import { LoadingStatuses } from 'core/common/entities';

export type ScanState = {
  processingStatus: LoadingStatuses;
};

export const scanInitialState: ScanState = {
  processingStatus: LoadingStatuses.IDLE,
};
